'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useASPInfo } from '@module/queries/asp/query';
import useModalStore from '@module/stores/useModalStore';
import { MODAL_TYPE_PC } from '@module/types/modal/type';
import BaseButton from '@pc/components/atoms/button/BaseButton';
import Cookies from 'js-cookie';
import type { ReactNode } from 'react';
function BroadcastStartButton(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const pushModal = useModalStore(_temp);
  const {
    isLogin,
    isLoginInfoLoading
  } = useGetLoginInfoQuery();
  const {
    data: aspInfo
  } = useASPInfo();
  if (aspInfo) {
    return;
  }
  let t1;
  if ($[0] !== isLogin || $[1] !== isLoginInfoLoading || $[2] !== pushModal) {
    t1 = () => {
      if (isLoginInfoLoading) {
        return;
      }
      if (Cookies.get("partner")?.includes("dcinside")) {
        pushModal({
          type: "CONFIRM_MODAL",
          id: "BroadcastStartButton",
          options: {
            content: <div className="flex flex-col items-center justify-center gap-4"><p className="text-center font-semibold text-[20px] text-colorFg01 tracking-tight">방송하기 이용 안내</p><p className="text-center font-normal text-[#777] text-[15px]">디시인사이드를 통해 가입한 회원님은 방송하기가 불가합니다.<br />팬더티비로 다시 회원가입하시면<br />방송하기를 이용하실 수 있습니다.</p></div>
          }
        });
        return;
      }
      if (isLogin) {
        pushModal({
          type: MODAL_TYPE_PC.BROADCAST_START_MODAL,
          id: "BroadcastStartButton"
        });
      } else {
        pushModal({
          type: MODAL_TYPE_PC.AUTH_MODAL,
          id: "BroadcastStartButton"
        });
      }
    };
    $[0] = isLogin;
    $[1] = isLoginInfoLoading;
    $[2] = pushModal;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mr-1 h-[36px] w-[36px] bg-50% bg-icon-broadcast bg-size-24 bg-no-repeat" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t1) {
    t3 = <><BaseButton className="mr-[7px] flex h-[40px] w-[120px] items-center justify-center rounded-[7px] border border-borderBg03 bg-colorBg15 px-2 text-[15px] text-baseFg hover:bg-[#5555550F]" onClick={t1}>{t2}{children}</BaseButton></>;
    $[5] = children;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(state) {
  return state.pushModal;
}
export default BroadcastStartButton;